import React from 'react';

const LegalNotice = () => {
  return (
    <div className="w-full text-center p-4 text-xs text-slate-500 border-t border-slate-200 mt-8 bg-slate-50">
      <p className="max-w-4xl mx-auto">
        This platform provides technology and workflow support. Legal services are provided by the participating law firm. Financial advisors do not provide legal advice through this platform.
      </p>
    </div>
  );
};

export default LegalNotice;